import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import '../css/BisharatMain.css';
import AuthService from "../services/AuthService";
import translate from "../languages/translate";

const email = value => {
  if (!isEmail(value)) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">{translate("email-not-validated")}</p>
      </div>
    );
  }
};


export default class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      email: "",
      password: "",
      loading: false,
      message: ""
    };
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.login(this.state.email, this.state.password).then(
        () => {
          //this.props.history.push("/");
          window.location.reload();
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          // Only show activation message when backend explicitly returns ACCOUNT_NOT_ACTIVATED
          // (never for bad credentials - security)
          const isAccountNotActivated =
            (typeof resMessage === "string" && resMessage === "ACCOUNT_NOT_ACTIVATED");

          this.setState({
            loading: false,
            message: isAccountNotActivated ? translate("check-ur-namil") : translate("user-pass-incorrect")
          });
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }


  requestAuths(username) {
    const loggedInUser = AuthService.getCurrentUser();
    if(loggedInUser.numberOfSendSMS > 3) {
      this.setState({
        successful: false,
        message: translate("too-much-tries")
      });
    } else {
    AuthService.reqToJoinNow(username)
    .then((response) => {
      localStorage.setItem("verifytry", "5");
        window.location.href = `/activateSMS/${username}`; 
         this.setState({
          successful:true,
          message:""});
    },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        resMessage === "10" ?  
        this.setState({
          successful: false,
          message:  translate("too-much-tries")
                }) : 
        this.setState({
          successful: false,
          message: resMessage
        });
  
      
      }
    )}
  }









  render() {

    const loggedInUser = AuthService.getCurrentUser();
    const handleBacktoMain = () => {
      //AuthService.logout();
      window.location = '/';
      //window.location.reload();
  }

  const handlegoToProfile = () => {
    //AuthService.logout();
    window.location = '/profile';
    //window.location.reload();
}
    
    const required = value => {
      if (!value) {
        return (
          <div className="alertDanger" >
               <p className="alertDanger">  
         {translate("mandatory")}        
          </p> 
          </div>
        );
      }
    };

    return (
      <div className='top-level-page-main login-page'>
    
      <div className="top-container-login">
           
        <div className="login-log">
    
      <h1>{translate("bisharat")}</h1>

{loggedInUser ?
            <div className="loggedIn">
             <button className="btn" onClick={handleBacktoMain}>  {translate("back-to-main")}  </button>
             {/* <p className="alertDanger">   {translate("family-per-content") }     </p> */}
             {/* <button onClick={handlegoToProfile} className="btn-small">{translate("request-family-permissions")}   </button> */}
            </div> 
            : 
            <div>
       <Form
            onSubmit={this.handleLogin}
            ref={c => {
              this.form = c;
            }}
          >
            <div className="form-group">
              <label htmlFor="email"> {translate("email")} </label>
              <Input
                type="text"
                className="form-control form-control-login"
                name="email"
                value={this.state.email}
                onChange={this.onChangeEmail}
                validations={[required, email]}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password"> {translate("password")}</label>
              <Input
                type="password"
                className="form-control form-control-login"
                name="password"
                value={this.state.password}
                onChange={this.onChangePassword}
                validations={[required]}
              />
            </div>

            <div className="form-group">
            <a href="/" className="btn">{translate("back-to-main")}  </a>
              <button
                className="btn"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                 {translate("login-now")}
              </button>
              
            </div>

            {this.state.message && (
              <div className="form-group">
                <div className="alertDanger" role="alert">
                  {this.state.message}
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
           
          </Form>
         
            <div className="register-button-span">
          <a href="/register" className="btn">   {translate("join-now")}</a>
          </div>
          <div className="register-button-span">
          <a href="/users/resetusernameorpassword" className="btn-reset-full-login"> {translate("restore-user-pass")}   </a>
          </div>
            </div> 
          }
        
        </div>
        </div>
      </div>
      
    );
  }
}